import { apiFetch } from '@/api'
import { Destination } from '@/interfaces'

export const fetchAllDestinations = async (): Promise<Destination> =>
  (await apiFetch('/destinations', { method: 'GET' })).data
